import React from 'react';
import { Clock, Shield, MapPin } from 'lucide-react';
import { translations } from '../utils/translations';
interface TrustBadgesProps {
  lang: string;
}
export function TrustBadges({
  lang
}: TrustBadgesProps) {
  const t = translations[lang as keyof typeof translations] || translations.en;
  const badges = [{
    id: 1,
    title: t.fastResponse,
    desc: t.fastResponseDesc,
    icon: <Clock className="w-10 h-10 text-brand-red" data-id="element-107" />
  }, {
    id: 2,
    title: t.insured,
    desc: t.insuredDesc,
    icon: <Shield className="w-10 h-10 text-brand-red" data-id="element-108" />
  }, {
    id: 3,
    title: t.coverage,
    desc: t.coverageDesc,
    icon: <MapPin className="w-10 h-10 text-brand-red" data-id="element-109" />
  }];
  return <section className="py-16 px-4 bg-brand-black border-y border-gray-900" data-id="element-110">
      <div className="max-w-6xl mx-auto" data-id="element-111">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-112">
          {badges.map(badge => <div key={badge.id} className="flex flex-col items-center text-center p-6 bg-brand-dark/50 rounded-xl border border-white/5" data-id="element-113">
              <div className="w-20 h-20 rounded-full bg-brand-red/10 flex items-center justify-center mb-6" data-id="element-114">
                {badge.icon}
              </div>
              <h3 className="text-2xl text-white mb-2" data-id="element-115">{badge.title}</h3>
              <p className="text-gray-400 font-body" data-id="element-116">{badge.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}